import { useMutation, useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "@/api/constants";

import { propertiesApi } from "./propertiesApi";
import type { InfoProperty, PropertyFillterParams } from "./types";

export const useGetAllProperties = (params?: PropertyFillterParams) => {
  return useQuery({
    queryKey: [QUERY_KEYS.property, params],
    queryFn: () => propertiesApi.getAllProperties(params),
  });
};

export const useCreateNewPropertyMutation = () => {
  return useMutation({
    mutationFn: (data: InfoProperty) => {
      return propertiesApi.postNewProperty(data);
    },
  });
};

export const useUpdatePropertyMutation = () => {
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: InfoProperty }) => {
      return propertiesApi.patchProperty(id, data);
    },
  });
};

export const useDeletePropertyMutation = () => {
  return useMutation({
    mutationFn: (id: string) => {
      return propertiesApi.deleteProperty(id);
    },
  });
};
